import http from 'utilities/http-common'

/**
 * Récupère les fichiers du journal channel pour une période donnée (channel master 1603 en dur)
 * @param {string} startDate - Date de début (format: YYYY-MM-DD)
 * @param {string} endDate - Date de fin (format: YYYY-MM-DD)
 * @returns {Promise} Liste des fichiers avec leurs détails
 */
const getJournalChannelFiles = (startDate, endDate) => {
    return http.get(`/api/v1/journal-channel-files`, {
        params: {
            startDate,
            endDate
        }
    })
}

/**
 * Télécharge le contenu d'un fichier (IN ou OUT) en base64
 * @param {number} idJournalChFIn - ID du fichier journal channel IN
 * @param {string} direction - Direction du fichier (IN ou OUT)
 * @returns {Promise} Contenu du fichier en base64
 */
const downloadFileContent = (idJournalChFIn, direction) => {
    return http.get(`/api/v1/journal-channel-files/${idJournalChFIn}/download`, {
        params: {
            direction
        }
    })
}

export default {
    getJournalChannelFiles,
    downloadFileContent
}
